<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

            <div v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <div v-if="role === 'SuperAdministrador'">
                <AccessibleElSelect
                  v-model="form.distribuidor.value"
                  prop="distribuidor"
                  :options="distribuidoresForAccessibleSelect"
                  :withFormItem="true"
                  id-prefix="configflowfilter"
                  @select="handleSelectDistribuidor"
                >
                  <template slot="label">{{$t('distributors.distributor')}}</template>
                </AccessibleElSelect>
              </div>

              <AccessibleElSelect
                v-model="form.empresa.value"
                prop="empresa"
                :options="clientesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="configflowfilter"
                @select="handleSelectCliente"
                @change="handleChangeCliente"
              >
                <template slot="label">{{$t('app.client')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.name')}}
                <el-form-item prop="Nombre">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.Nombre.value"
                    maxlength="100"
                  />
                </el-form-item>
              </label>
            </div>
            
             <div>
              <AccessibleElSelect
                v-model="form.Activo.value"
                prop="Activo"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="configflowfilter"
              >
                <template slot="label">{{$t('app.active')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configflow.TemporizadorDias')}}
                <el-form-item prop="TemporizadorDias">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.TemporizadorDias.value"
                    min="0"
                    max="9999999999"
                    type="number"
                  />
                </el-form-item>
              </label>
            </div>

             <div>
              <AccessibleElSelect
                v-model="form.estadoOrigen.value"
                prop="estadoOrigen"
                :options="tiposEstadoDescargaForAccessibleSelect"
                :withFormItem="true"
                id-prefix="configflowfilter"
              >
                <template slot="label">{{$t('app.estado_origen')}}</template>
              </AccessibleElSelect>
            </div>
            
             <div>
              <AccessibleElSelect
                v-model="form.estadoDestino.value"
                prop="estadoDestino"
                :options="tiposEstadoDescargaForAccessibleSelect"
                :withFormItem="true"
                id-prefix="configflowfilter"
              >
                <template slot="label">{{$t('app.estado_destino')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.nombre_cif')}}
                <el-form-item prop="NombreCIF">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.NombreCIF.value"
                    maxlength="150"
                  />
                </el-form-item>
              </label>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.cif')}}
                <el-form-item prop="cif">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.cif.value"
                    maxlength="50"
                  />
                </el-form-item>
              </label>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.codPGN.value"
                prop="codPGN"
                :options="sedesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="configflowfilter"
              >
                <template slot="label">{{$t('app.location')}}</template>
              </AccessibleElSelect>
            </div>
            
            <div>
              <AccessibleElSelect
                v-model="form.organismo.value"
                prop="organismo"
                :options="organismosForAccessibleSelect"
                :withFormItem="true"
                :remote="true"
                :remote-method="remoteOrganismos"
                popperClass="wrap-select-popover"
                :loading="loadingOrganismos"
                id-prefix="configflowfilter"
              >
                <template slot="label">
                  <div class="flex items-center gap-x-2">
                    {{$t('app.organismo')}}
                    <base-tooltip-icon size="sm" :content="'Escribe para iniciar la búsqueda'"/>
                  </div>
                </template>
              </AccessibleElSelect>
            </div>

              <div>
                <AccessibleElSelect
                  v-model="form.nombreGrupoPropietario.value"
                  prop="nombreGrupoPropietario"
                  :options="listaGroupsGroupingOwnerForAccessibleSelect"
                  :group="true"
                  id-prefix="configflowfilter"
                >
                  <template slot="label">{{$t('notificationFilter.group_owner')}}</template>
                </AccessibleElSelect>
              </div>
            
             <div>
              <AccessibleElSelect
                v-model="form.EnviarCorreosPrincipales.value"
                prop="EnviarCorreosPrincipales"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="configflowfilter"
              >
                <template slot="label">{{$t('configflow.EnviarCorreosPrincipales')}}</template>
              </AccessibleElSelect>
            </div>
            
             <div>
              <AccessibleElSelect
                v-model="form.EnviarCorreosSecundarios.value"
                prop="EnviarCorreosSecundarios"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="configflowfilter"
              >
                <template slot="label">{{$t('configflow.EnviarCorreosSecundarios')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configflow.EmailGenerico')}}
                <el-form-item prop="email">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.email.value"
                    maxlength="500"
                  />
                </el-form-item>
              </label>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getClients } from '@/services/clients/getClients'
import { TIPOS_ESTADO_DESCARGA } from '@/config/tipos-estado-descarga'
import { getLocations } from '@/services/app/getLocations'
import { getSedesByEmpresa } from '@/services/app/getSedesByEmpresa'
import { getOrganismosAll } from '@/services/configurations/getOrganismosAll'
import { getGroupsNames } from '@/services/configurations/groups/getGroupsNames'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'configflow',
      tiposEstadoDescarga: TIPOS_ESTADO_DESCARGA,
      isOpen: this.panelOpen,
      links: [],
      sedes: [],
      valuesOrganismos: [],
      loadingOrganismos: false,
      valuesNombresGrupos: [],
      form: {
        Nombre: { label: i18n.t('configurations.name'), value: '' },
        Activo: { label: i18n.t('app.active'), value: '' },
        TemporizadorDias: { label: i18n.t('configflow.TemporizadorDias'), value: '' },
        EstadoInicial: { label: i18n.t('app.estado_origen'), value: '' },
        EnviarCorreosPrincipales: { label: i18n.t('configflow.EnviarCorreosPrincipales'), value: '' },
        EnviarCorreosSecundarios: { label: i18n.t('configflow.EnviarCorreosSecundarios'), value: '' },
        email: { label: i18n.t('configflow.EmailGenerico'), value: '' },      
        estadoOrigen: { label: i18n.t('app.estado_origen'), value: '' },
        estadoDestino: { label: i18n.t('app.estado_destino'), value: '' },
        cif: { label: i18n.t('companies.cif'), value: '' },
        NombreCIF: { label: i18n.t('app.nombre_cif'), value: '' },
        codPGN: { label: i18n.t('app.location'), value: '' },
        organismo: { label: i18n.t('app.organismo'), value: '' },
        nombreGrupoPropietario: { label: i18n.t('notificationFilter.group_owner'), value: '' },  
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' }
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      distribuidores: [],
      clientes: [],
    }
  },

  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    },
    'form.empresa.value': {
      handler: 'loadGroups'
    }
  },
  mounted: async function () {
    let locs
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      locs = await getLocations()
      if (locs.blnError) {
        this.doFeedback(locs.msgError + ' [Código de error: ' + locs.codError + ']')
      }
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas

      if (this.role === 'SuperAdministrador') {
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(dataDistributors.msgError + ' [Código de error: ' + dataDistributors.codError + ']')
        }
        this.distribuidores = dataDistributors.Distribuidores
      }
    } else {
      locs = await getSedesByEmpresa()
      if (locs.blnError === true) {
        this.doFeedback(locs.msgError + ' [Código de error: ' + locs.codError + ']')
      }
    }

    if (!locs.blnError) {
      locs.PGNS.forEach(row => {
        this.sedes.push({ id: row.IdPGN, label: row.Nombre, value: row.Codigo })
      })
      this.sedes.unshift({ id: 0, value: 'Manual' })
      if (this.hasModuleHotFolder) this.sedes.unshift({ id: -1, value: 'Email' })
    }

    await this.loadGroups()
  },
  computed: {
    listaGroupsGroupingOwner () {
      if (this.valuesNombresGrupos.length > 0) {
        const options = []
        this.valuesNombresGrupos.forEach(x => {
          if (options.filter(y => y.label === x.Tipo).length === 0) {
            options.push(
              { label: x.Tipo, options: [] }
            )
          }
        })
        this.valuesNombresGrupos.forEach(x => {
          const index = options.map(x => x.label).indexOf(x.Tipo)
          options[index].options.push(
            {
              value: x.Nombre,
              label: x.Nombre,
            }
          )
        })
        return options
      }
      return []
    },
    listaGroupsGroupingOwnerForAccessibleSelect () {
      return this.listaGroupsGroupingOwner.map(group => ({
        label: group.label,
        options: group.options.map(opt => ({ id: opt.value, value: opt.value, name: opt.label }))
      }))
    },
    distribuidoresForAccessibleSelect: function () {
      return this.distribuidores.map(item => ({
        id: item.IdDistribuidor,
        name: item.Nombre,
        value: item.Nombre
      }))
    },
    clientesForAccessibleSelect: function () {
      return this.clientes.map(item => ({
        id: item.IdEmpresa,
        name: item.Nombre,
        value: item.Nombre
      }))
    },
    valuesForAccessibleSelect: function () {
      return this.values.map(item => ({
        id: item.value,
        name: item.label
      }))
    },
    tiposEstadoDescargaForAccessibleSelect: function () {
      return this.tiposEstadoDescarga.map(item => ({
        id: item.id,
        name: item.Nombre
      }))
    },
    sedesForAccessibleSelect: function () {
      return this.sedes.map(item => ({
        id: item.id,
        name: item.label || item.value,
        value: item.value
      }))
    },
    organismosForAccessibleSelect: function () {
      return this.valuesOrganismos.map(item => ({
        id: item.id,
        name: item.label,
        value: item.value
      }))
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasModuleHotFolder () {
      return this.$store.getters['auth/hasModuleHotFolder']
    },
  },
  methods: {
    loadGroups: async function () {
      const cliente = this.clientes.find(c => c.Nombre === this.form.empresa.value)
      const gruposUsuario = await getGroupsNames({ incluirReparto: false, idCliente: cliente?.IdEmpresa })
      if (gruposUsuario.blnError) {
        this.doFeedback(gruposUsuario.msgError + ' [Código de error: ' + gruposUsuario.codError + ']')
      } else {
        this.valuesNombresGrupos = gruposUsuario.Respuesta
      }
    },
    handleChangeCliente: function () {
      const campos = [this.form.nombreGrupoPropietario]
      if (campos.some(campo => campo.value)) {
        campos.forEach(campo => { campo.value = '' })
        this.doFeedback('Se han realizado cambios en el formulario: se han limpiado los filtros de grupo al cambiar el cliente.', 'info', 5000)
      }
    },
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.Nombre.value = _temp.Nombre !== undefined && _temp.Nombre.value !== '' ? _temp.Nombre.value : ''
        this.form.Activo.value = _temp.Activo !== undefined && _temp.Activo.value !== '' ? _temp.Activo.value : ''
        this.form.TemporizadorDias.value = _temp.TemporizadorDias !== undefined && _temp.TemporizadorDias.value !== '' ? _temp.TemporizadorDias.value : ''
        this.form.EstadoInicial.value = _temp.EstadoInicial !== undefined && _temp.EstadoInicial.value !== '' ? _temp.EstadoInicial.value : ''
        this.form.EnviarCorreosPrincipales.value = _temp.EnviarCorreosPrincipales !== undefined && _temp.EnviarCorreosPrincipales.value !== '' ? _temp.EnviarCorreosPrincipales.value : ''
        this.form.EnviarCorreosSecundarios.value = _temp.EnviarCorreosSecundarios !== undefined && _temp.EnviarCorreosSecundarios.value !== '' ? _temp.EnviarCorreosSecundarios.value : ''
        this.form.email.value = _temp.email !== undefined && _temp.email.value !== '' ? _temp.email.value : ''

        this.form.estadoOrigen.value = _temp.estadoOrigen !== undefined && _temp.estadoOrigen.value !== '' ? _temp.estadoOrigen.value : ''
        this.form.estadoDestino.value = _temp.estadoDestino !== undefined && _temp.estadoDestino.value !== '' ? _temp.estadoDestino.value : ''
        this.form.cif.value = _temp.cif !== undefined && _temp.cif.value !== '' ? _temp.cif.value : ''
        this.form.NombreCIF.value = _temp.NombreCIF !== undefined && _temp.NombreCIF.value !== '' ? _temp.NombreCIF.value : ''
        this.form.codPGN.value = _temp.codPGN !== undefined && _temp.codPGN.value !== '' ? _temp.codPGN.value : ''
        this.form.organismo.value = _temp.organismo !== undefined && _temp.organismo.value !== '' ? _temp.organismo.value : ''
        this.form.nombreGrupoPropietario.value = _temp.nombreGrupoPropietario !== undefined && _temp.nombreGrupoPropietario.value !== '' ? _temp.nombreGrupoPropietario.value : ''

        this.form.empresa.value = _temp.empresa !== undefined && _temp.empresa.value !== '' ? _temp.empresa.value : ''
        this.form.distribuidor.value = _temp.distribuidor !== undefined && _temp.distribuidor.value !== '' ? _temp.distribuidor.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        Nombre: { label: i18n.t('configurations.name'), value: '' },
        Activo: { label: i18n.t('app.active'), value: '' },
        TemporizadorDias: { label: i18n.t('configflow.TemporizadorDias'), value: '' },
        EstadoInicial: { label: i18n.t('app.estado_origen'), value: '' },
        EnviarCorreosPrincipales: { label: i18n.t('configflow.EnviarCorreosPrincipales'), value: '' },
        EnviarCorreosSecundarios: { label: i18n.t('configflow.EnviarCorreosSecundarios'), value: '' },
        email: { label: i18n.t('configflow.EmailGenerico'), value: '' },
        estadoOrigen: { label: i18n.t('app.estado_origen'), value: '' },
        estadoDestino: { label: i18n.t('app.estado_destino'), value: '' },
        cif: { label: i18n.t('companies.cif'), value: '' },
        NombreCIF: { label: i18n.t('app.nombre_cif'), value: '' },
        codPGN: { label: i18n.t('app.location'), value: '' },
        organismo: { label: i18n.t('app.organismo'), value: '' },  
        nombreGrupoPropietario: { label: i18n.t('notificationFilter.group_owner'), value: '' },
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' }
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    querySearch: function (queryString, cb) {
      const links = this.links
      const results = queryString ? links.filter(this.createFilter(queryString)) : links
      // call callback function to return suggestions
      cb(results)
    },
    createFilter: function (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSelect: function (item) {
      // console.log(item)
    },
    handleSelectCliente: function (item) {
      this.form.empresa.value = item.id
    },
    handleSelectDistribuidor: function (item) {
      this.form.distribuidor.value = item.id
    },
    formatNombreOrg (element) {
      return element.Nombre + ' - ' + element.CIF
    },
    remoteOrganismos: async function (query) {
      this.valuesOrganismos = []
      if (query !== '' && this.loadingOrganismos === false && query.length > 2) {
        this.loadingOrganismos = true
        setTimeout(async () => {
          const organismos = await getOrganismosAll({ filtro: query })
          if (organismos.blnError === true) {
            this.doFeedback(organismos.msgError + ' [Código de error: ' + organismos.codError + ']')
          }
          if (organismos.DatosOrganismos !== undefined && organismos.DatosOrganismos?.length > 0) {
            let organismosMatch = []
            if (organismos.DatosOrganismos.length > 200) {
              organismosMatch = organismos.DatosOrganismos.filter(x => x.CIF.toUpperCase() === query.toUpperCase() || x.Nombre.toUpperCase() === query.toUpperCase())
              if (organismosMatch.length > 0) {
                this.doFeedback('Se han encontrado resultados coincidentes, pero se ha excedido el límite para los que contienen la búsqueda. Si el resultado esperado no aparece, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              } else {
                this.doFeedback('Se ha excedido el límite de resultados en la búsqueda. Por favor, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              }
            } else {
              organismosMatch = organismos.DatosOrganismos
            }
            organismosMatch.forEach(element => {
              this.valuesOrganismos.push(
                { 
                  id: element.idOrganismo, 
                  value: element.Nombre,
                  label: this.formatNombreOrg(element),
                }
              )
            })
          }
          this.loadingOrganismos = false
        }, 200)
      }
    }
  }
}
</script>
